import { Component, OnInit, HostListener } from '@angular/core';
import { AuthenticationService } from '../../../services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  public hide = false;
  public happyHours = false;
  loggedInUser: any;
  categoryName: any;

  constructor(
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService
  ) { }

  @HostListener('window:resize')
  onResize(): void {
    document.body.classList.remove('sidebar-open');
  }

  ngOnInit(): void {
    if (localStorage.getItem('userRole') === 'admin') {
      this.loggedInUser = JSON.parse(localStorage.getItem('admin') || 'null');
      this.hide = true;
    } else if (localStorage.getItem('userRole') === 'user') {
      this.loggedInUser = JSON.parse(localStorage.getItem('user') || 'null');
    }
  }

  isSidebarOpenState(): boolean {
    return document.body.classList.contains('sidebar-open');
  }

  closeSidebar(): void {
    document.body.classList.remove('sidebar-open');
  }

  logout(event?: Event): void {
    event?.preventDefault();
    const adminJson = localStorage.getItem('admin');
    const userJson = localStorage.getItem('user');
    const currentAdmin = adminJson ? JSON.parse(adminJson) : null;
    const currentUser = userJson ? JSON.parse(userJson) : null;
    const userId = currentUser && currentUser.id ? String(currentUser.id) : '';

    if (currentAdmin) {
      localStorage.removeItem('admin');
      localStorage.removeItem('userRole');
      this.toastr.success('Admin Successfully Logged Out');
      this.router.navigate(['/login']);
    } else {
      this.authenticationService.userLogout(userId).subscribe((res: any) => {
        if (res && res.status === 200) {
          localStorage.removeItem('user');
          localStorage.removeItem('userRole');
          this.toastr.success(res.message);
          this.router.navigate(['/login']);
        } else {
          this.toastr.error(res.message, 'Unable to logout!', { progressBar: true });
        }
      });
    }

    this.closeSidebar();
  }
}
